import localstorageUtil from "../utils/localstore.util";

class Auth {
  /**
   * Check if a JWT token is expired by decoding its payload.
   * Returns true if expired or malformed.
   */
  private static isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      if (!payload.exp) return false; // no expiry claim = treat as valid
      return payload.exp * 1000 < Date.now();
    } catch {
      return true; // malformed token = treat as expired
    }
  }

  /**
   * Check if a user is authenticated via localStorage tokens.
   * Also verifies the token has not expired.
   *
   * @returns {boolean}
   */
  static isUserAuthenticat() {
    const token = localstorageUtil.get_data("token");
    const adminToken = localstorageUtil.get_data("Admintoken");
    const activeToken = token || adminToken;

    if (!activeToken) return false;
    if (Auth.isTokenExpired(activeToken)) {
      Auth.deauthenticateLocalUser();
      return false;
    }
    return true;
  }

  /**
   * Deauthenticate a user. Remove all data from localStorage.
   */
  static deauthenticateLocalUser() {
    localstorageUtil.remove_all();
  }
}

export default Auth;
